export default "__VITE_PUBLIC_ASSET__3cd29bf9__"